export default __webpack_public_path__ + "static/media/logo-large.fe7c85da.svg";